import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@nexus/ui";
import { useDisconnectVendor } from "@/lib/queries";

interface DisconnectDialogProps {
  connectionId: string;
  vendorName: string;
  tenantId: string;
  open: boolean;
  onClose: () => void;
}

export function DisconnectDialog({
  connectionId,
  vendorName,
  tenantId,
  open,
  onClose,
}: DisconnectDialogProps) {
  const { t } = useTranslation();
  const disconnectMutation = useDisconnectVendor();

  async function handleDisconnect() {
    await disconnectMutation.mutateAsync({ connectionId, tenantId });
    onClose();
  }

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("marketplace.connections.disconnectDialog.title", { vendorName })}
          </DialogTitle>
          <DialogDescription>
            {t("marketplace.connections.disconnectDialog.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={disconnectMutation.isPending}
          >
            {t("marketplace.connections.disconnectDialog.cancel")}
          </Button>
          <Button
            type="button"
            variant="destructive"
            disabled={disconnectMutation.isPending}
            onClick={handleDisconnect}
          >
            {disconnectMutation.isPending
              ? t("marketplace.connections.disconnectDialog.disconnecting")
              : t("marketplace.connections.disconnectDialog.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
